module.exports = __webpack_public_path__ + "res/dummy_reels_sp1.3758bfc67dcaa9725b9dd643e524d44a.mp4";